import { Accordion, AccordionTab } from "primereact/accordion";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Checkbox } from "primereact/checkbox";
import { Tooltip } from "primereact/tooltip";
import { useDeleteFuturePlan } from "../../hooks/useGetDataQuery";
import { useEffect, useRef, useState } from "react";
import { useToastContext } from "../../Lib/Contexts/toastContext";

const ExerciceAccordion = ({
    activeIndex,
    setActiveIndex,
    selectedExercise,
    setSelectedExercise,
    planList,
    setPlanList,
    selectedPlan,
    selectPlan,
    onSelectedPlanExerciseClick,
    planTimeLine,
    lang,
    t
}: any) => {

    const {
        mutate: deleteFuturePlanMutation,
        isSuccess: isSuccessDeleteFuturePlanMutation,
    } = useDeleteFuturePlan();

    const averageSuccessTooltipRef = useRef<Tooltip>(null);
    const progressRateTooltipRef = useRef<Tooltip>(null);
    const toleranceTooltipRef = useRef<Tooltip>(null);

    const [deletedPlanId, setDeletedPlanId] = useState<any>()
    const [stateOfAccordion, setStateOfAccordion] = useState<any>(0);
    const { showToast } = useToastContext();

    useEffect(() => {
        if (isSuccessDeleteFuturePlanMutation) {
            setPlanList((prevPlanList: any) =>
                prevPlanList.filter((plan: any) => plan.planId !== deletedPlanId)
            );
            showToast({ severity: 'success', summary: t("success"), detail: t("planDeletedSuccess"), });
        }
    }, [isSuccessDeleteFuturePlanMutation]);


    const deleteFuturePlan = (planId: any, e: any) => {
        e.stopPropagation();
        setDeletedPlanId(planId);
        deleteFuturePlanMutation(planId);
    }

    function formatDateRange(startISO: any, endISO: any) {
        const options: any = { day: '2-digit', month: 'short' };
        const start = new Date(startISO);
        const end = new Date(endISO);

        const startFormatted = start.toLocaleDateString(lang, options);
        const endFormatted = end.toLocaleDateString(lang, options);

        return `${startFormatted} - ${endFormatted}`;
    }

    function getColorOfSuccessPercentage(percent: number) {
        return percent >= 70
            ? "#23CF95"
            : percent >= 30
                ? "#FF7527"
                : "#E3506B"
    }

    const onAccordionTabChange = (index: any) => {
        setActiveIndex(index)
        if (index !== null) {
            if (stateOfAccordion === index) {
                if (selectedPlan) {
                    selectPlan(planList[index], true, index);
                }
            }
            else {
                selectPlan(planList[index], true, index);
            }

            setStateOfAccordion(index);
        }
    }

    const headeContent = (plan: any, index: any) => {
        return (
            <div className="flex justify-content-between gap-2">
                <div className="flex align-items-center justify-content-start gap-4">
                    <div className="p-3 w-3rem h-3rem flex align-items-center justify-content-center"
                        style={activeIndex === index ? { backgroundColor: "#FFFFFF", borderRadius: "10px" } : { backgroundColor: "#E0E3EE", borderRadius: "10px" }}>
                        <i className={activeIndex === index ? "pi pi-angle-up text-2xl" : "pi pi-angle-down text-2xl"} style={{ color: "#2D3967" }}></i>
                    </div>
                    <div className="flex flex-column gap-2">
                        <p className="m-0 font-bold text-md" style={{ color: "#2D3967" }}>{plan.planName}</p>
                        <div className="flex gap-4 align-items-center">
                            <p className="m-0 font-bold text-xs" style={{ color: "#2D3967" }}>{formatDateRange(plan.planStartDate, plan.planEndDate)}</p>
                            <div className="flex align-items-center">
                                <Checkbox onClick={(e) => e.stopPropagation()} onChange={e => selectPlan(plan, e.checked, index)} checked={selectedPlan?.planId === plan.planId}></Checkbox>
                                <label className="ml-2 text-xs" style={{ color: "#2D3967" }}>{t("selectAll")}</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="flex gap-2">
                    {/* {(planTimeLine === t("ongoing") || planTimeLine === t("upcoming")) &&
                        <Button
                            icon={<img src="/pencilIcon.svg" width={25} />}
                            style={{
                                border: "none",
                                backgroundColor: "#FFFFFF",
                                borderRadius: "10px",
                                width: "2rem",
                                height: "2rem"
                            }} />} */}
                    {planTimeLine === t("ongoing") &&
                        <Button
                            icon={<img src="/closeIcon.svg" width={20} />}
                            style={{
                                border: "none",
                                backgroundColor: "#FFFFFF",
                                borderRadius: "10px",
                                width: "2rem",
                                height: "2rem"
                            }} />}
                    {planTimeLine === t("upcoming") &&
                        <Button
                            icon={<img src="/trashWhiteIcon.svg" width={25} />}
                            onClick={(e) => { deleteFuturePlan(plan.planId, e) }}
                            style={{
                                border: "none",
                                backgroundColor: "#E97389",
                                borderRadius: "10px",
                                width: "2rem",
                                height: "2rem"
                            }} />}


                    {planTimeLine === t("completed") &&
                        <Button
                            icon={<img src="/archiveIcon.svg" width={25} />}
                            style={{
                                border: "none",
                                backgroundColor: "#FFFFFF",
                                borderRadius: "10px",
                                width: "2rem",
                                height: "2rem"
                            }} />}
                </div>
            </div>

        )
    }

    useEffect(() => {
        if(selectedPlan) {
            progressRateTooltipRef.current?.updateTargetEvents();
            averageSuccessTooltipRef.current?.updateTargetEvents();
            toleranceTooltipRef.current?.updateTargetEvents();
        }
    }, [selectedPlan])

    const onExerciseClick = (exercise:any) => {
        onSelectedPlanExerciseClick();
        setSelectedExercise(exercise);
    }

    const exerciseDivs = (plan: any) => {
        return plan?.exerciseList?.map((exercise: any) => {
            const nonZeroSuccessValues = exercise?.exerciseTimeLine?.filter((item: any) => item.successPercentage > 0).map((item: any) => item.successPercentage) || [];
            const averageSuccessPercentage = nonZeroSuccessValues.length > 0
                ? Math.round(nonZeroSuccessValues.reduce((acc: number, val: number) => acc + val, 0) / nonZeroSuccessValues.length)
                : 0;

            const allCompletionValues = exercise?.exerciseTimeLine?.map((item: any) => item.completionPercentage || 0) || [];
            const averageCompletionPercentage = allCompletionValues.length > 0
                ? Math.round(allCompletionValues.reduce((acc: number, val: number) => acc + val, 0) / allCompletionValues.length)
                : 0;

            const emergencyStopBadge = exercise.isEmergencyStopped ? (
                <span
                    className="flex align-items-center justify-content-center"
                    style={{
                        position: "absolute",
                        top: "0rem",
                        right: "0rem",
                        width: "1.25rem",
                        height: "1.25rem",
                        borderRadius: "50%",
                        backgroundColor: "#DC2626",
                        color: "#FFFFFF",
                        fontSize: "0.7rem",
                        fontWeight: "bold",
                        lineHeight: 1,
                        zIndex: 1,
                    }}
                    aria-hidden
                >
                    ES
                </span>
            ) : null;

            if (selectedPlan) {
                return (
                    <Card className="mt-2 ml-4 cursor-pointer" style={{ background: "#EBEEFF", position: "relative" }} onClick={() => onExerciseClick(exercise)}>
                        {emergencyStopBadge}
                        <div className="flex gap-4 align-items-center justify-content-between my-1 mx-2 p-2 pr-3">
                            <div className="flex gap-4 align-items-center">
                                <Checkbox checked={true} id={exercise.id} onChange={() => onExerciseClick(exercise)}></Checkbox>
                                <img src={exercise.exerciseImg} style={{ backgroundColor: "#FFFFFF", borderRadius: "10px", objectFit: "contain", width: "3rem", height: "3rem", flexShrink: 0 }} />
                                <p className="font-bold text-md m-0" style={{ color: "#2D3967" }}>{exercise.exerciseName}</p>
                            </div>
                            <div className="flex flex-column gap-2 align-items-start">
                                <p className="text-xs font-bold m-0" style={{ color: "#2D3967" }}>
                                    {exercise.sets + "x" + exercise.repeats},
                                    <span 
                                        className="tolerance-tooltip text-xs font-bold m-0 toleranceSpan"
                                        data-pr-tooltip={t("tolerance")}
                                    >
                                        {" " + exercise.tolerance + "%"}
                                    </span>    
                                </p>
                                <p 
                                    className="text-nm font-bold m-0 average-success-tooltip" 
                                    style={{ color: getColorOfSuccessPercentage(averageSuccessPercentage) }}
                                    data-pr-tooltip={t("success")}
                                >
                                    {averageSuccessPercentage + "%"}
                                </p>
                            </div>
                        </div>
                        <div 
                            className="progress-rate-tooltip"
                            style={{ width: "100%", height: "4px", border: "1px solid #9EA4B9", borderRadius: "2px", position: "relative", overflow: "hidden" }}
                            data-pr-tooltip={`${t("complition")}: ${averageCompletionPercentage}%`}
                        >
                            <div style={{ 
                                width: `${averageCompletionPercentage}%`, 
                                height: "100%", 
                                border: "1px solid #2D3967",
                                backgroundColor: "#2D3967",
                                borderRadius: "2px"
                            }}></div>
                        </div>
                    </Card>
                )
            } else {
                return (
                    <Card
                        className="mt-2 ml-4 cursor-pointer"
                        style={
                            selectedExercise?.exerciseId === exercise?.exerciseId
                                ? { background: "#EBEEFF", position: "relative" }
                                : { background: "#F6F5F8", position: "relative" }
                        }
                        onClick={() => setSelectedExercise(exercise)}
                    >
                        {emergencyStopBadge}
                        <div className="flex gap-4 align-items-center my-1 mx-2 p-2 pr-5">
                            <Checkbox onChange={() => setSelectedExercise(exercise)} checked={exercise?.exerciseId === selectedExercise?.exerciseId} id={exercise.id}></Checkbox>
                            <img src={exercise.exerciseImg} style={{ backgroundColor: "#FFFFFF", borderRadius: "10px", objectFit: "contain", width: "3rem", height: "3rem", flexShrink: 0 }} />
                            <p className="font-bold text-md m-0" style={{ color: "#2D3967" }}>{exercise.exerciseName}</p>
                            <p className="text-xs align-self-end font-bold m-0 ml-auto" style={{ color: "#2D3967" }}>{exercise.sets + "x" + exercise.repeats}</p>
                        </div>
                    </Card>
                );
            }

        });

    }


    const createDynamicTabs = () => {
        return planList.map((plan: any, index: any) => {
            return (
                <AccordionTab key={plan.id} header={() => headeContent(plan, index)}>
                    {exerciseDivs(plan)}
                </AccordionTab>
            );
        });
    };

    return (
        <>
            <Tooltip ref={averageSuccessTooltipRef} target=".average-success-tooltip" />
            <Tooltip ref={progressRateTooltipRef} target=".progress-rate-tooltip" />
            <Tooltip ref={toleranceTooltipRef} target=".tolerance-tooltip" />
            <Accordion activeIndex={activeIndex} onTabChange={(e) => onAccordionTabChange(e.index)}>
                {createDynamicTabs()}</Accordion>
        </>
    )
}

export default ExerciceAccordion;